"use strict";

exports.__esModule = true;
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _executeBound = _interopRequireDefault(require("./_executeBound.js"));
var _underscore = _interopRequireDefault(require("./underscore.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var partial = (0, _restArguments.default)(function (func, boundArgs) {
  var placeholder = partial.placeholder;
  var _bound = function bound() {
    var position = 0,
      length = boundArgs.length;
    var args = Array(length);
    for (var i = 0; i < length; i++) {
      args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
    }
    while (position < arguments.length) args.push(arguments[position++]);
    return (0, _executeBound.default)(func, _bound, this, this, args);
  };
  return _bound;
});
partial.placeholder = _underscore.default;
var _default = exports.default = partial;